import {useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'

import Header from '../../components/header/Header.jsx'
import ListItems from './listItems/ListItems.jsx'
import CartStepsButton from './cartStepsButton/CartStepsButton.jsx'
import DescriptionValues from './descriptionValues/DescriptionValues.jsx'
import Scan from '../../components/scan/Scan.jsx'

import {Snackbar} from '@mui/material'
import {
    getLocal,
    getSession,
    removeLocal,
    removeSession,
    setLocal,
    setSession
} from '../../hooks/useStorage/useStorage.jsx'
import {
    colors,
    findProductBySku,
    getMode,
    log,
    newOrderId,
    tokenizeCard
} from '../../utils/utils.jsx'
import {
    DialogAddCardCredit,
    DialogCashback,
    DialogDiscountCoupon,
    DialogLoading, DialogOptionConsume,
    DialogOrderConfirmation, DialogPaymentMethods,
    DialogPermissionCamera, DialogPermissionDeniedCamera,
    DialogProfile,
    DialogTable,
    DialogWarning
} from '../../components/dialogs/Dialogs.jsx'
import {getDiscountCoupon, sendOrder, sendLog, getCashback, getConsultation} from '../../services/Apis.jsx'

import {isDebug, isEmpty, isIOS, isMobile, searchEmJSON} from 'react-lf-tools'

import {ShoppingCartContext} from '../../context/ShoppingCartContext'
import {general as textsGeneral, shoppingCart as textsShoppingCart} from '../../translate/Translate.jsx'
import moment from 'moment'
import {motion} from 'framer-motion'

import './shoppingCart.scss'
import themeMui from "../../themeMui.jsx";
import {ThemeProvider} from "@mui/material/styles";

const ShoppingCart = () => {
    const navigate = useNavigate()
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })
    const [items, setItems] = useState([])
    const [discount, setDiscount] = useState(0)
    const [totalItems, setTotalItems] = useState(0)
    const [deliveryFee, setDeliveryFee] = useState(0)
    const [total, setTotal] = useState(0)
    const [isAddItem, setAddItem] = useState('')
    const [answersQuestions, setAnswersQuestions] = useState([])
    const [isVisibleAddress, setVisibleAddress] = useState(true)
    const [cashbackBonus, setCashbackBonus] = useState(0)
    const [restartButton, setRestartButton] = useState('')
    const [scan, setScan] = useState(false)
    const [cashback, setCashback] = useState({
        balance: 0,
        rescue: 0,
        cpf: ''
    })
    const [dialogOrderConfirmation, setDialogOrderConfirmation] = useState({
        open: false
    })
    const [dialogProfile, setDialogProfile] = useState({
        open: false
    })
    const [dialogLoading, setDialogLoading] = useState({
        open: false,
        message: ''
    })
    const [dialogDiscountCoupon, setDialogDiscountCoupon] = useState({
        open: false
    })
    const [dialogWarning, setDialogWarning] = useState({
        open: false,
        title: '',
        message: ''
    })
    const [dialogCashback, setDialogCashback] = useState({
        open: false
    })
    const [dialogTable, setDialogTable] = useState({
        open: false
    })
    const [dialogPaymentMethods, setDialogPaymentMethods] = useState({
        open: false
    })
    const [dialogAddCardCredit, setDialogAddCardCredit] = useState({
        open: false
    })
    const [dialogPermissionCamera, setDialogPermissionCamera] = useState({
        open: false
    })
    const [dialogPermissionDeniedCamera, setDialogPermissionDeniedCamera] = useState({
        open: false
    })
    const [dialogOptionConsume, setDialogOptionConsume] = useState({
        open: false
    })
    const handleMessage = (message) => setSnackbar({
        open: true,
        message: message
    })

    const handleCloseSnackbar = () => setSnackbar({open: false})

    const handleResult = ({text}) => {
        try {
            if (!text) return setSnackbar({
                open: true,
                message: textsGeneral.scanReadingError
            })
            if (text.includes('http'))
                qrCode(text)
            else
                barCode(text)
        } catch (e) {
            setSnackbar({open: true, message: e.message})
        } finally {
            setScan(false)
        }
    }

    const qrCode = qrCode => {
        qrCode = qrCode.substring(qrCode.indexOf('?') + 1)
        qrCode = atob(qrCode)
        qrCode = searchEmJSON(qrCode, 0)
        setSession('card', qrCode.cartao)
        requestSendOrder()
    }

    const barCode = barCode => {
        setSession('card', barCode)
        requestSendOrder()
    }

    const handleError = (error) => setDialogWarning({
        open: true,
        message: error
    })

    const handleCancel = () => setScan(false)

    const handleClickDialogWarning = () => setDialogWarning({...dialogWarning, open: false})

    const handleCloseDialogCashback = () => setDialogCashback({...dialogCashback, open: false})

    const handleClickDialogCashback = rescue => {
        if (rescue <= 0) {
            removeSession('rescue')
        } else {
            setSession('rescue', rescue)
            deleteDiscountCoupon()
        }
        setCashback({...cashback, rescue: rescue})
        handleCloseDialogCashback()
    }

    const handleCloseTable = () => setDialogTable({open: false})

    const handleClickTable = (table) => {
        setSession('table', table)
        setSession('tableOld', table)
        handleCloseTable()
        handleClickNext()
    }

    const handleClosePaymentMethods = () => {
        setDialogPaymentMethods({open: false})
    }

    const handleClickPaymentMethods = async (payment) => {
        setSession('payment', payment)
        if (payment.code === 'ONLINE') {
            setDialogAddCardCredit({open: true})
        } else {
            handleClickNext()
        }
        setDialogPaymentMethods({open: false})
    }

    const handleCloseDialogAddCardCredit = () => {
        setDialogAddCardCredit({open: false})
    }

    const handleClickDialogAddCardCredit = () => {
        setDialogAddCardCredit({open: false})
        handleClickNext()
    }

    const handleClosePermissionCamera = () => setDialogPermissionCamera({open: false})

    const handleClickPermissionCamera = () => {
        handleClosePermissionCamera()
        setDialogOrderConfirmation({open: false})
        setScan(true)
    }

    const handleClosePermissionDeniedCamera = () => setDialogPermissionDeniedCamera({open: false})

    const handleClickPermissionDeniedCamera = () => {
        handleClosePermissionDeniedCamera()
        if (isIOS()) {
            window.open('https://www.youtube.com/shorts/E3bz35aI-kA', '_blank')
        } else if (!isMobile) {
            window.open('https://support.google.com/chrome/answer/2693767?hl=pt-BR&co=GENIE.Platform%3DDesktop&oco=0', '_blank')
        } else {
            window.open('https://www.youtube.com/shorts/hH5zDvZKsoQ', '_blank')
        }
    }

    const handleClickOptionConsume = orderTakeAway => {
        setSession('orderTakeAway', orderTakeAway)
        setDialogOptionConsume({open: false})
        handleClickNext()
    }

    const handleChangeItem = item => {
        if (item.isCouponProduct) return
        const product = findProductBySku(item)
        navigate('/sacola', {
            state: {
                product: product,
                edit: true,
                item: item,
                isCouponProduct: false
            }
        })
    }

    const handleChangeQuantityItems = (item, type = 'add') => {
        try {
            const index_item = items.findIndex((i) => (i.id === item.id))
            if ((type === 'remove') && (item.amount === 1)) {
                items.splice(index_item, 1)
                deleteDiscountCoupon(true)
            } else {
                const amount = (type === 'add') ? (++item.amount) : (--item.amount)
                const subitemsValue = totalOfSubitems(item.subitems)
                items[index_item].amount = amount
                items[index_item].price = ((item.priceProduct + subitemsValue) * amount)
            }
            setAddItem(!isAddItem)
            setLocal('items', items)
            setItems(items)
            checkItems()
            checkDiscountPercentage()
        } catch (e) {
            log(e.message, 'error')
        }
    }

    const totalOfSubitems = (subitems) => {
        let total = 0
        subitems.forEach((subitem) => {
            total += subitem.sku.includes('S') ? (subitem.valuePercentage * subitem.amount) : (subitem.priceProduct * subitem.amount)
        })
        return total
    }

    const handleChangeCleanCart = () => {
        const items = getLocal('items', [])
        const totalItems = getSession('totalItems', 0)
        removeLocal('items')
        navigate(-1)
    }

    const handleClickNext = () => {
        const items = getLocal('items', [])
        const profile = getLocal('profile', {})
        const table = getSession('table', '')
        const tableOld = getSession('tableOld')
        const mode = getSession('mode')
        const payment = getSession('payment') || null
        const identifyTableManually = getLocal('identifyTableManually')

        const reponseCoupon = checkValueDiscountCoupon()
        if (!items.length) {
            navigate(-1)
        } else if (reponseCoupon.check) {
            setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: `${textsShoppingCart.minimumPurchaseDiscountNotice} ${parseFloat(reponseCoupon.value).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                })}`
            })
        } else if (isEmpty(profile)) {
            setDialogProfile({open: true})
        } else if (mode === 'desk' && identifyTableManually && !tableOld) {
            setDialogTable({open: true})
        } else if (mode !== 'desk' && !table) {
            setDialogTable({open: true})
        } else if (mode === 'desk' && !payment) {
            setDialogPaymentMethods({open: true})
        } else {
            setDialogOrderConfirmation({open: true})
        }
    }

    const checkValueDiscountCoupon = () => {
        const discountCoupon = getSession('discountCoupon', {})
        const value = discountCoupon.minimum_purchase || 0
        return {
            check: (value > total),
            value: value
        }
    }

    const handleClickDiscountCoupon = (action) => {
        if (action === 'insert') {
            setDialogDiscountCoupon({open: true})
        } else {
            deleteDiscountCoupon()
        }
    }

    const handleClickCashback = () => {
        const gularisMinimum = getLocal('gularisMinimum')
        if (cashback.balance < gularisMinimum) return setSnackbar({
            open: true,
            message: `${textsShoppingCart.minimumRescue} ${gularisMinimum.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            })}`
        })
        setDialogCashback({...dialogCashback, open: true})
    }

    const deleteDiscountCoupon = () => {
        const discountCoupon = getSession('discountCoupon', {})
        if (!isEmpty(discountCoupon)) setDialogWarning({
            open: true,
            title: textsGeneral.warning,
            message: textsShoppingCart.couponRemoved
        })
        const index = items.findIndex((fi) => fi.isCouponProduct)
        if (index !== -1) {
            items.splice(index, 1)
            setItems(items)
            setLocal('items', items)
            checkItems()
        }
        removeSession('discountCoupon')
        removeSession('discount')
        setDiscount(0)
    }

    const handleCloseDiscountCoupon = () => setDialogDiscountCoupon({open: false})

    const handleConfirmDiscountCoupon = async (discountCoupon) => {
        try {
            setDialogDiscountCoupon({open: false})
            if (totalItems === 0) return setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: textsShoppingCart.addItemsToUseTheCoupon
            })
            setDialogLoading({open: true, message: textsShoppingCart.checkingDiscountCoupon})
            const response = await getDiscountCoupon(discountCoupon)
            if (response.sucesso)
                checkTypesDiscountCoupon(response, discountCoupon)
            else setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: response.mensagem
            })
        } finally {
            setDialogLoading({open: false, message: ''})
        }
    }

    const checkTypesDiscountCoupon = (response, discountCoupon) => {
        const {tipo_desconto: discount_type} = response
        switch (discount_type) {
            case 'DELIVERY_FEE':
                discountTypeDelivery(response, discountCoupon)
                break
            case 'VALUE':
                discountTypeValue(response, discountCoupon)
                break
            case'PERCENTAGE':
                discountTypePercentage(response, discountCoupon)
                break
            default:
                discountTypeProduct(response, discountCoupon)
                break
        }
    }

    const discountTypeDelivery = (response, discountCoupon) => {
        const {compra_minima: minimum_purchase} = response
        const deliveryMode = getLocal('deliveryMode')
        const deliveryFee = getSession('deliveryFee')
        if (deliveryMode === 'takeaway') return setDialogWarning({
            open: true,
            title: textsGeneral.warning,
            message: textsShoppingCart.deliveryCouponInvalidForTakeaway
        })
        if (totalItems >= parseFloat(minimum_purchase)) {
            setSession('discountCoupon', {
                type: 'DELIVERY_FEE',
                discountCoupon: discountCoupon,
                value: deliveryFee,
                minimum_purchase: minimum_purchase
            })
            setSession('discount', deliveryFee)
            setDiscount(deliveryFee)
            removeCashback()
        } else {
            messageMinimumPurchase(minimum_purchase)
        }
    }

    const discountTypeValue = (response, discountCoupon) => {
        const {compra_minima: minimum_purchase, valor: value} = response
        if (totalItems >= parseFloat(minimum_purchase)) {
            setSession('discountCoupon', {
                type: 'VALUE',
                discountCoupon: discountCoupon,
                value: parseFloat(value),
                minimum_purchase: minimum_purchase
            })
            setSession('discount', parseFloat(value))
            setDiscount(parseFloat(value))
            removeCashback()
        } else {
            messageMinimumPurchase(minimum_purchase)
        }
    }

    const discountTypePercentage = (response, discountCoupon) => {
        const {compra_minima: minimum_purchase, desconto_max: max_discount, valor: value} = response
        if (totalItems >= parseFloat(minimum_purchase)) {
            const discountAmount = (totalItems * (parseFloat(value) / 100))
            const discount = ((discountAmount <= parseFloat(max_discount)) || (parseFloat(max_discount) === 0)) ? discountAmount : parseFloat(max_discount)
            setSession('discountCoupon', {
                type: 'PERCENTAGE',
                discountCoupon: discountCoupon,
                value: discount,
                minimum_purchase: parseFloat(minimum_purchase),
                max_discount: parseFloat(max_discount),
                percentage: parseFloat(value)
            })
            setSession('discount', discount)
            setDiscount(discount)
            removeCashback()
        } else {
            messageMinimumPurchase(minimum_purchase)
        }
    }

    const discountTypeProduct = (response, discountCoupon) => {
        const {compra_minima: minimum_purchase, desconto_max: max_discount, valor: value} = response
        if (totalItems >= parseFloat(minimum_purchase)) {
            const product = findProductBySku({sku: value})
            if (isEmpty(product)) return setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: textsShoppingCart.productNotFound
            })
            if ((product.variations.length === 0) || !(product.variations.some((f) => (f.options.length > 1)))) {
                setSession('discountCoupon', {
                    type: 'FREE_PRODUCT',
                    discountCoupon: discountCoupon,
                    value: product.price,
                    minimum_purchase: parseFloat(minimum_purchase)
                })
                setSession('discount', product.price)
                setDiscount(product.price)
                addItem(product)
                removeCashback()
            } else {
                let valueDiscount = product.price
                product.variations.forEach((v) => {
                    if ((v.minSelection === 1 && v.maxSelection === 1) && (v.options.length === 1)) {
                        valueDiscount += v.options[0].price
                    }
                })
                setSession('discountCoupon', {
                    type: 'FREE_PRODUCT',
                    discountCoupon: discountCoupon,
                    value: valueDiscount,
                    minimum_purchase: parseFloat(minimum_purchase)
                })
                navigate('/sacola', {
                    state: {
                        product: product,
                        edit: false,
                        item: {},
                        isCouponProduct: true
                    }
                })
            }
        } else {
            messageMinimumPurchase(minimum_purchase)
        }
    }

    const addItem = product => {
        const itemToCreate = {
            id: moment().toDate().getTime(),
            sku: product.sku,
            image: product.image,
            product: product.product,
            amount: 1,
            priceProduct: product.price,
            price: product.price,
            observation: '',
            subitems: [],
            datetime: moment().toDate(),
            isCouponProduct: true
        }
        items.push(itemToCreate)
        setItems(items)
        setLocal('items', items)
        checkItems()
    }

    const messageMinimumPurchase = (minimum_purchase) => setDialogWarning({
        open: true,
        title: textsGeneral.warning,
        message: `${textsShoppingCart.minimumPurchaseDiscountNotice} ${parseFloat(minimum_purchase).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        })}`
    })

    const handleCloseOrderConfirmation = () => setDialogOrderConfirmation({open: false})

    const handleEditOrderConfirmation = (type) => {
        switch (type) {
            case 'table':
                setDialogTable({open: true})
                break
            case 'orderTakeAway':
                setDialogOptionConsume({open: true})
                break
            case 'typeOrder':
                setDialogOptionConsume({open: true})
                break
            case 'payment':
                setDialogPaymentMethods({open: true})
                break
            default:
                setDialogProfile({open: true})
                break
        }
    }

    const removeCashback = () => {
        const rescue = getSession('rescue', '')
        if (!!rescue) setDialogWarning({
            open: true,
            title: textsGeneral.warning,
            message: textsShoppingCart.cashbackRemoved
        })
        removeSession('rescue')
        setCashback({...cashback, rescue: 0})
    }

    const handleClickOrderConfirmation = async () => {
        const mode = getSession('mode', '')
        if (mode === 'card') {
            const cameraPermission = await checkPermissionCamera()
            if (cameraPermission) {
                setDialogOrderConfirmation({open: false})
                setScan(true)
                return
            }
            return
        }
        setDialogOrderConfirmation({open: false})
        requestSendOrder()
    }

    const checkPermissionCamera = async () => {
        const cameraPermission = getLocal('cameraPermission', false)
        if (cameraPermission) return cameraPermission
        if (navigator.permissions && navigator.permissions.query) {
            const permissionStatus = await new Promise((resolve, reject) => navigator.permissions.query({name: 'camera'})
                .then((permission) => resolve(permission.state))
                .catch((error) => reject(error)))
            if (permissionStatus === 'prompt') {
                setDialogPermissionCamera({open: true})
                return false
            } else if (permissionStatus === 'denied') {
                setDialogPermissionDeniedCamera({open: true})
                return false
            } else {
                return true
            }
        }
    }

    const requestSendOrder = async () => {
        const order = orderData()
        if (isDebug('5173') && import.meta.env.VITE_AUTHKEY !== 'DEMO_FELIPE') {
            log(order)
            return
        }
        setDialogLoading({open: true, message: textsShoppingCart.sendingRequest})
        const {returnCode, message, chave} = await sendOrder(order)
        setDialogLoading({...dialogLoading, open: false})

        if (!!returnCode) {
            order.chave = chave
            postOrderRecords(order)
            recordHistory(order)
            const request = requestLog(order)
            const log = await sendLog(request, 'POST')
            const updateOrder = {...order, logStatus: log || {}}
            setLocal('orderOld', updateOrder)
            navigate(-1)
        } else {
            setDialogLoading({
                open: true,
                message: message
            })
        }
    }

    const requestLog = order => {
        const authkey = getLocal('authkey')
        const idStore = getLocal('idStore')
        return JSON.stringify({
            authkey_id: `${authkey}_${idStore}`,
            pedido: order,
            version: import.meta.env.VITE_VERSION_NAME,
            key: order.id_pedido,
        })
    }

    const postOrderRecords = order => {
        const item = getLocal('items')
        setSession('itemsOld', item)
        setLocal('orderOld', order)
        removeLocal('items')
        removeLocal('intervalID')
        clearTable()
        newOrderId()
    }

    const clearTable = () => {
        try {
            const identifyTableManually = getLocal('identifyTableManually')
            const tableOld = getSession('tableOld')
            if (identifyTableManually) removeSession('tableOld')
        } catch (e) {

        }
    }

    const recordHistory = order => {
        const history = getLocal('history', [])
        history.unshift(order)
        setLocal('history', history)
    }

    const handleClickProfile = (profile) => {
        const b = getLocal('profile', '')
        setDialogProfile({open: false})
        setLocal('profile', profile)
        if (!b) {
            handleClickNext()
        }
    }

    const handleCloseProfile = () => setDialogProfile({open: false})

    const orderData = () => {
        const authkey = getLocal('authkey')
        const idStore = getLocal('idStore')
        const profile = getLocal('profile')
        const orderId = getLocal('orderId', new Date().getTime().toString())
        const mode = getMode()
        const table = getSession('table', '')
        const card = getSession('card', '')
        const payment = getSession('payment') || null
        const totalItems = getSession('totalItems', 0)

        const order = {
            authkey: authkey,
            id_loja: idStore,
            versao: import.meta.env.VITE_VERSION_NAME,
            token: '01E6D456-F22F-40FF-9276-8B8892A287C4',
            bitmenuQrCode: true,
            dataHora: moment().format('YYYY-MM-DD HH:mm:ss'),
            id_pedido: orderId,
            tipo_pedido: mode,
            total_produtos: totalItems,
            nro_mesa: table,
            setor: getSession('sector', ''),
            itens: formatItems(),

            obs: '',
            retorno: {
                status: 'PENDENTE'
            },
            cliente_cpf: profile.cpf || '',
            cliente_nome: profile.name,
            cliente_telefone: profile.phone || '',
            levar: getSession('orderTakeAway', false)
        }

        if (mode !== 'balcao')
            order.comandas = (mode === 'comanda') ? [parseInt(card)] : [parseInt(table)]

        if (mode === 'balcao') {
            if (payment?.code === 'PIX') order.expire = moment().add(15, 'minutes')
            delete order['nro_mesa']
        }

        if (payment?.code) {
            const pagamentos = {
                ONLINE: () => {
                    const card = getSession('card')
                    return [{
                        ccc: ccc(payment, orderId),
                        codigo: code(payment),
                        bandeira: card?.type?.toUpperCase() ?? '',
                        valorPago: totalItems
                    }]
                },
                PIX: () => [{
                    codigo: 'PIX',
                    valorPago: totalItems
                }]
            }
            order.pagamentos = pagamentos[payment.code]?.() ?? []
        }

        return order
    }

    const dateTime = (date, time) => {
        if (!!date) {
            return `${date} ${time}`
        } else if (!!time) {
            return moment(time, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        } else {
            return moment().format('YYYY-MM-DD HH:mm:ss')
        }
    }

    const formatItems = () => {
        const items = getLocal('items')
        const a = []
        items.forEach((it) => a.push({
            fracionado: false,
            hora: it.datetime,
            obs: it?.observation || '',
            preco: it.price,
            precoProduto: it.priceProduct,
            quantidade: it.amount,
            sku: it.sku,
            titulo: it.product,
            subItens: formatSubItems(it.subitems)
        }))
        return a
    }

    const formatSubItems = (subItems) => {
        const array = []
        subItems.forEach((subitem) => array.push({
            preco: subitem.price,
            precoProduto: subitem.priceProduct,
            quantidade: subitem.amount,
            sku: subitem.sku,
            titulo: subitem.option,
            etapa: subitem?.step
        }))
        return array
    }

    const ccc = (payment, orderId) => {
        const card = getSession('card', {})
        if (payment.code !== 'ONLINE' || isEmpty(card)) return null
        return tokenizeCard(card, orderId)
    }

    const code = payment => {
        if (payment.description.toLowerCase() === 'pagamento online') {
            const card = getSession('card', {})
            const paymentTypes = getLocal('paymentTypes', [])
            for (let i = 0; paymentTypes.length; i++) {
                if ((paymentTypes[i].online === 'True') && (paymentTypes[i].description.toUpperCase().includes(card.type.toUpperCase()))) {
                    return paymentTypes[i].code
                }
            }
        }
        return payment.code
    }

    const checkItems = () => {
        try {
            const items = getLocal('items', [])
            const data = getLocal('data')
            const menu = data.menu

            const v1 = []
            items.forEach((item) => {
                const itemTime = moment(item.datetime).add(1, 'hour')
                const currentTime = moment()
                if (currentTime.isBefore(itemTime)) {
                    v1.push(item)
                }
            })

            const v2 = []
            v1.forEach((item) => {
                menu.forEach((menu) => {
                    if ((menu.category !== 'Destaques')) {
                        menu.products.forEach((product) => {
                            if ((item.sku === product.sku) && (item.priceProduct === product.price)) {
                                v2.push(item)
                            }
                        })
                    }
                })
            })

            if ((items.length !== 0) && (v2.length === 0)) setSnackbar({
                open: true, message: textsShoppingCart.itemsRemovedFromCart
            })

            let totalItems = 0
            v2.forEach((item) => (totalItems += item.price))
            setTotalItems(totalItems)
            setSession('totalItems', totalItems)
            setItems(v2)
            setLocal('items', v2)
        } catch (e) {
            log(e.message, 'error')
        }
    }

    const checkDiscountCoupon = () => {
        const items = getLocal('items', [])
        if (items.length === 0) return deleteDiscountCoupon()
        const discountCoupon = getSession('discountCoupon', {})
        const deliveryMode = getLocal('deliveryMode')
        const deliveryFee = getSession('deliveryFee')
        if (!isEmpty(discountCoupon)) {
            if (discountCoupon.type === 'VALUE') {
                setSession('discount', discountCoupon.value)
                setDiscount(discountCoupon.value)
                removeCashback()
            } else if (discountCoupon.type === 'FREE_PRODUCT') {
                const isCouponProduct = items.some((item) => (item.isCouponProduct))
                if (isCouponProduct) {
                    setSession('discount', discountCoupon.value)
                    setDiscount(discountCoupon.value)
                    removeCashback()
                } else {
                    deleteDiscountCoupon()
                }
            } else if (discountCoupon.type === 'DELIVERY_FEE') {
                if ((deliveryMode === 'takeaway') || (deliveryFee === 0)) {
                    deleteDiscountCoupon()
                } else {
                    discountCoupon.value = deliveryFee
                    setSession('discountCoupon', discountCoupon)
                    setSession('discount', deliveryFee)
                    setDiscount(deliveryFee)
                    removeCashback()
                }
            } else if (discountCoupon.type === 'PERCENTAGE') {
                checkDiscountPercentage()
            }
        }
    }

    /*const checkCashbackValue = () => {
        const items = getLocal('items', [])
        let cashbackValue = 0
        items.forEach(item => {
            cashbackValue += (item.price * (item.porcentage / 100))
        })
        setCashbackBonus(cashbackValue)
    }*/

    const checkDiscountPercentage = () => {
        const discountCoupon = getSession('discountCoupon', {})
        if (!isEmpty(discountCoupon)) {
            const totalItems = getSession('totalItems')
            const discountAmount = (totalItems * (discountCoupon.percentage / 100))
            const discount = ((discountAmount <= discountCoupon.max_discount) || (discountCoupon.max_discount === 0)) ? discountAmount : discountCoupon.max_discount
            discountCoupon.value = discount
            setSession('discountCoupon', discountCoupon)
            setSession('discount', discount)
            setDiscount(discount)
            removeCashback()
        }
    }

    const checkCashbackClient = async () => {
        const profile = getLocal('profile', {})
        const gularisToken = getLocal('gularisToken', '')
        if (!isEmpty(profile) && !isEmpty(gularisToken)) {
            const rescue = getSession('rescue', 0)
            if (!!rescue) setCashback({...cashback, rescue: rescue})
            const result = await getCashback(profile.cpf, gularisToken)
            if (result.status === 'success') {
                setCashback({...cashback, balance: result.data.saldo, cpf: result.data.cpf, rescue: rescue})
            } else {
                setCashback({balance: 0, rescue: 0, cpf: ''})
                removeSession('rescue')
            }
        }
    }

    useEffect(() => {
        checkItems()
        checkDiscountCoupon()
        //checkCashbackValue()
        checkCashbackClient()

    }, [])

    const calculateTotal = () => {
        const total = (((totalItems + deliveryFee) - discount) - cashback.rescue)
        setTotal(total)
    }

    useEffect(() => {
        calculateTotal()
    }, [totalItems, deliveryFee, discount, cashback])

    const handlePressShoppingCart = event => {
        if (event.key === 'Escape') {
            navigate(-1)
        } else if (event.key === 'F2') {
            handleClickDiscountCoupon('insert')
        } else if (event.key === 'F3') {
            handleClickNext()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handlePressShoppingCart, false)
        return () => document.removeEventListener('keydown', handlePressShoppingCart, false)
    }, [])

    if (scan) return <Scan onResult={handleResult} onError={handleError} onCancel={handleCancel}/>

    const styles = getLocal('colors')

    colors(document)

    return <ThemeProvider theme={themeMui(styles)}>
        <ShoppingCartContext.Provider
            value={{
                isAddItem,
                setAddItem,
                deliveryFee,
                totalItems,
                discount,
                answersQuestions,
                setAnswersQuestions,
                isVisibleAddress,
                setVisibleAddress,
                cashbackBonus,
                restartButton,
                setRestartButton,
            }}>
            <motion.div
                className={'shopping-cart'}
                initial={{x: 400}}
                animate={{x: 0}}
                transition={{duration: 0.3}}>
                <Header title={textsGeneral.shoppingCart} buttonBack={true}/>
                <div className={'container-shopping-cart'}>
                    <ListItems
                        items={items}
                        clickItem={handleChangeItem}
                        clickQuantity={handleChangeQuantityItems}
                        cleanCart={handleChangeCleanCart}/>
                    {/*<EatHere*/}
                    {/*    onClick={handleClickEatHere}*/}
                    {/*/>*/}
                    <DescriptionValues/>
                    <CartStepsButton
                        total={total}
                        clickNext={handleClickNext}/>

                </div>
                <>
                    {(dialogOrderConfirmation.open) && <DialogOrderConfirmation
                        open={dialogOrderConfirmation.open}
                        onClose={handleCloseOrderConfirmation}
                        onEdit={handleEditOrderConfirmation}
                        onClick={handleClickOrderConfirmation}/>
                    }
                    {(dialogProfile.open) && <DialogProfile
                        open={dialogProfile.open}
                        onMessage={handleMessage}
                        onClose={handleCloseProfile}
                        onClick={handleClickProfile}
                    />}
                    {(dialogDiscountCoupon.open) && <DialogDiscountCoupon
                        open={dialogDiscountCoupon.open}
                        onMessage={handleMessage}
                        onClose={handleCloseDiscountCoupon}
                        onClick={handleConfirmDiscountCoupon}/>
                    }
                    <DialogWarning
                        open={dialogWarning.open}
                        title={dialogWarning.title}
                        message={dialogWarning.message}
                        onClick={handleClickDialogWarning}
                    />
                    {(dialogCashback.open) && <DialogCashback
                        open={dialogCashback.open}
                        cashback={cashback}
                        onClose={handleCloseDialogCashback}
                        onClick={handleClickDialogCashback}
                    />}
                    <DialogLoading
                        open={dialogLoading.open}
                        message={dialogLoading.message}/>
                    <DialogTable
                        open={dialogTable.open}
                        onClose={handleCloseTable}
                        onClick={handleClickTable}
                    />
                    <DialogPaymentMethods
                        open={dialogPaymentMethods.open}
                        onClose={handleClosePaymentMethods}
                        onClick={handleClickPaymentMethods}
                    />
                    <DialogAddCardCredit
                        open={dialogAddCardCredit.open}
                        onClose={handleCloseDialogAddCardCredit}
                        onClick={handleClickDialogAddCardCredit}
                    />
                    <DialogPermissionCamera
                        open={dialogPermissionCamera.open}
                        onClose={handleClosePermissionCamera}
                        onClick={handleClickPermissionCamera}
                    />
                    <DialogPermissionDeniedCamera
                        open={dialogPermissionDeniedCamera.open}
                        onClose={handleClosePermissionDeniedCamera}
                        onClick={handleClickPermissionDeniedCamera}
                    />
                    <DialogOptionConsume
                        open={dialogOptionConsume.open}
                        onClick={handleClickOptionConsume}
                    />
                    <Snackbar
                        open={snackbar.open}
                        autoHideDuration={1600}
                        onClose={handleCloseSnackbar}
                        message={snackbar.message}/>
                </>
            </motion.div>
        </ShoppingCartContext.Provider>
    </ThemeProvider>
}

export default ShoppingCart
